"use strict";
angular.module("planCommandRegionalHotspotsRouterModule", [])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.regionalhotspots", {
                url: '/regionalhotspots',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspots_tpl.html',
                        controller: 'planCommandMonitorRegionalHotFeatureListCtrl'
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.regionalhotfeaturelist", {
                url: '/regionalhotfeaturelist',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotFeatureList/regionalHotFeatureList_tpl.html',
                        controller: 'planCommandMonitorRegionalHotFeatureListCtrl',
                    },
                    'nav@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspotsNav_tpl.html',
                        controller: 'regionalHotspotsNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.customhotspotcontentmgr", {
                url: '/customhotspotcontentmgr',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/customHotspotContentMgr/customHotspotContentMgr_tpl.html',
                        controller: 'planCommandMonitorCustomHotspotContentMgrController',
                    },
                    'nav@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspotsNav_tpl.html',
                        controller: 'regionalHotspotsNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.zjhotspotcontentmgr", {
                url: '/zjhotspotcontentmgr',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/zjHotspotContentMgr/zjHotspotContentMgr_tpl.html',
                        controller: 'planCommandMonitorZjHotspotContentMgrController',
                    },
                    'nav@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspotsNav_tpl.html',
                        controller: 'regionalHotspotsNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.countryhotspotcontentmgr", {
                url: '/countryhotspotcontentmgr',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/countryHotspotContentMgr/countryHotspotContentMgr_tpl.html',
                        controller: 'planCommandMonitorCountryHotspotContentMgrController',
                    },
                    'nav@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspotsNav_tpl.html',
                        controller: 'regionalHotspotsNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.internationalhotspotcontentmgr", {
                url: '/internationalhotspotcontentmgr',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/internationalHotspotContentMgr/internationalHotspotContentMgr_tpl.html',
                        controller: 'planCommandMonitorInterHotspotContentMgrController',
                    },
                    'nav@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl: './planningResource/commandMonitor/regionalHotspots/regionalHotspotsNav_tpl.html',
                        controller: 'regionalHotspotsNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.regionalhotspots.regionalHotspotsrelatedarticle",{
                url:'/regionalHotspotsrelatedarticle?search_hour&areahot_id&hot_type&correlationNews_title',
                views: {
                    'main@front.planningresource.commandMonitor.regionalhotspots': {
                        templateUrl:'./planningResource/commandMonitor/regionalHotspots/regionalHotspotsRelatedArticle/regionalHotspotsRelatedArticle_tpl.html',
                        controller:'planCommandMonitorRegionalHotspotsRelateArticleCtrl',
                    }
                }
            });
    }]);
